import styled from "styled-components";
import * as vars from "../shared/variables";
import {layout, space, variant} from "styled-system";

import {getTheme} from "../shared/themeUtils";
import { Spinner } from "react-bootstrap";

interface ButtonProps {
  /**
   * The type of button
   */
  variant?: "primary" | "secondary" | "underline" | "transparent" | "border";
  /**
   * Defines the font size of the text
   */
  fontSize?: string;
  /**
   * Custom width, accepts percentages, em/rem, px
   */
  width?: string;
  /**
   * Label, children content
   */
  children?: any;
  /**
   * Accepts class names
   */
  className?: string;
  /**
   * Click event
   */
  onClick?: () => void;
  /**
   * Is disabled
   */
  disabled?: boolean;
  /**
   * Loading status
   */
  isLoading?: boolean;
}

const MainButton = styled.button`
  ${space};
  ${layout};
  color: #fff;
  border-radius: 4px;
  padding: 8px 1.5rem;
  font-size: .9rem;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid ${getTheme("colors.primary")};
  position: relative;
  text-align: center;
  ${variant({
    variants: {
      primary: {
        backgroundColor: vars.primaryColor,
        fill: "#fff",
        transition: "all .2s",
        "&:hover": {
          opacity: .9
        },
        "&:disabled": {
          opacity: .8,
          cursor: "not-allowed"
        }
      },
      secondary: {
        backgroundColor: vars.backgroundColor,
        border: "none",
        color: vars.primaryColor,
        transition: "all .2s",
        "&:disabled": {
          opacity: .8,
          cursor: "not-allowed"
        }
      },
      underline: {
        backgroundColor: "transparent",
        color: vars.primaryColor,
        border: "none",
        textDecoration: "underline"
      },
      transparent: {
        backgroundColor: "transparent",
        color: vars.primaryColor,
        border: "none",
        padding: "8px"
      },
        border: {
            backgroundColor: "transparent",
            color: vars.primaryColor,
            border: `2px solid ${vars.primaryColor}`
      }
    }
  })}
`

/**
 * Main Button used for user interaction
 */
const Button = (props: ButtonProps) => {

  return (
    // @ts-ignore
    (<MainButton disabled={props.disabled || props.isLoading} width={props.width} variant={props.variant} onClick={props.onClick} className={props.className}>
      {!props.isLoading && props.children}
      {props.isLoading && <Spinner animation="border" size="sm"/>}
    </MainButton>)
  );
}

export default Button;
